import CryptoJS from "crypto-js";


let socketInstance = null;

export const setSocketInstance = (socket) => {
  socketInstance = socket;
};

export const getSocketInstance = () => {
  return socketInstance;
};


const secretKey32 = process.env.REACT_APP_LOGIN_SECRET_32KEY;
const secretKey16 = process.env.REACT_APP_LOGIN_SECRET_16KEY;

export const encryptToken = (token) => {
  const key = CryptoJS.enc.Utf8.parse("P7-)-*Ob^DS7s;-Cv-ZJ6@4Y22m@besr");
  const iv = CryptoJS.enc.Utf8.parse(secretKey16);
  return CryptoJS.AES.encrypt(token, key, { iv: iv }).toString();
};

export const decryptToken = (encryptedToken) => {
  const key = CryptoJS.enc.Utf8.parse("P7-)-*Ob^DS7s;-Cv-ZJ6@4Y22m@besr");
  const iv = CryptoJS.enc.Utf8.parse(secretKey16);
  const decrypted = CryptoJS.AES.decrypt(encryptedToken, key, { iv: iv });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
